import { useState, useEffect } from "react";
import { Table, Pagination, Space, Popconfirm, Spin, message, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";
import { get, del } from "../../services";
import { month, getDateHandler } from "../../utils/dateHandler";
import { tokenExpired } from "../../utils/tokenExpired";

const Tasks = () => {
  const date = new Date();
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const limit = 10;

  // Method for API call
  const getAllTasks = (currentPage) => {
    setLoader(true);
    get(`/tasks/getTasks?page=${currentPage}&limit=${limit}`)
      .then((response) => {
        setTasks(response?.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        // to check token if token expired then logout user
        tokenExpired(err?.response?.data?.message, navigate);
      });
  };

  //  GET All Admins
  useEffect(() => {
    getAllTasks(currentPage);
    // eslint-disable-next-line
  }, []);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    // API call to delete selected record
    del(`/tasks/${data?._id}`)
      .then(() => {
        // to delete locally from our frontend lists
        const remaingRecords = tasks?.tasks?.filter(
          (item) => item?._id !== data?._id
        );
        setTasks({ ...tasks, tasks: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  // Cancel
  const cancel = (e) => {
    console.log(e);
  };

  const colorHandler = () => {
    if ("Pending") {
      return "volcano";
    } else if ("In Progress") {
      return "geekblue";
    } else if ("Completed") {
      return "green";
    } else return "volcano";
  };

  // Table Columns
  const columns = [
    {
      title: "Sr",
      dataIndex: "",
      key: "sr",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Property",
      dataIndex: "",
      key: "",
      render: (data) => (
        <Space size="middle">
          {data?.listingId?.name ? data?.listingId?.name : "-"}
        </Space>
      ),
    },
    {
      title: "Due Date",
      key: "dueDate",
      dataIndex: "dueDate",
      render: (data) => (
        <Space size="middle">
          {getDateHandler(data) +
            "-" +
            month[date?.getMonth(data)] +
            "-" +
            date?.getFullYear(data)}
        </Space>
      ),
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (status) => (
        <>
          <Tag color={colorHandler()} key={status}>
            {status}
          </Tag>
        </>
      ),
    },
    {
      title: "Action",
      key: "",
      render: (data) => (
        <div className="flex">
          <div className="px-4">
            <EditOutlined
              className="cursor-pointer"
              onClick={() => {
                navigate(`/edit-task/${data?._id}`);
              }}
            />
          </div>
          <div className="px-4">
            {data?._id === selectedRecord ? (
              <Spin />
            ) : (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => confirm(data)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteFilled className="cursor-pointer" />
              </Popconfirm>
            )}
          </div>
        </div>
      ),
    },
  ];
  console.log("task", tasks);

  return (
    <div>
      <div className="header4">
        <h3>Tasks</h3>
        <div className="events-button">
          <Link to="/create-task">
            <button className="cursor-pointer add-event">Create Task</button>
          </Link>
        </div>
      </div>
      {/* table */}
      <Table
        columns={columns}
        dataSource={tasks?.tasks}
        loading={loader}
        pagination={false}
        scroll={{ x: 1023 }}
      />
      <Pagination
        defaultPageSize={currentPage}
        showSizeChanger={false}
        current={currentPage}
        pageSize={limit}
        total={tasks?.totalPages}
        onChange={(e) => {
          setCurrentPage(e);
          getAllTasks(e);
        }}
        className="pagination"
      />
    </div>
  );
};
export default Tasks;
